import styled from 'styled-components';

export default styled.div`
    & > * {
      &:not(:first-child) {
        margin-top: 10px;
      }
    }
`
